// extracted by mini-css-extract-plugin
export default {"cta":"WH-z","disabled":"XH-z"};